module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-accounts",
    style: ({
      'height': _vm.deviceHeight
    })
  }, [_c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t\"同意\"餐企订单同时发送Excel到绑定邮箱\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.excelChange
    },
    model: {
      value: (_vm.excelFlag),
      callback: function($$v) {
        _vm.excelFlag = $$v
      },
      expression: "excelFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t允许餐企撤销订货单\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.cancelFlagChange
    },
    model: {
      value: (_vm.cancelFlag),
      callback: function($$v) {
        _vm.cancelFlag = $$v
      },
      expression: "cancelFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t允许餐企发货后撤销订货单\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.sendCancelChange
    },
    model: {
      value: (_vm.sendCancelFlag),
      callback: function($$v) {
        _vm.sendCancelFlag = $$v
      },
      expression: "sendCancelFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t订单显示金额\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.moneyChange
    },
    model: {
      value: (_vm.moneyFlag),
      callback: function($$v) {
        _vm.moneyFlag = $$v
      },
      expression: "moneyFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t订单显示发货实收数量\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.actualNumChange
    },
    model: {
      value: (_vm.actualNumFlag),
      callback: function($$v) {
        _vm.actualNumFlag = $$v
      },
      expression: "actualNumFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t订单显示辅助单位和数量\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.actualAssistNumChange
    },
    model: {
      value: (_vm.actualAssistNumFlag),
      callback: function($$v) {
        _vm.actualAssistNumFlag = $$v
      },
      expression: "actualAssistNumFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t订单显示品项编号\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.itemCodeChange
    },
    model: {
      value: (_vm.itemCodeFlag),
      callback: function($$v) {
        _vm.itemCodeFlag = $$v
      },
      expression: "itemCodeFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listview-div"
  }, [_vm._v("\n\t\t订单分享显示仓库\n\t\t"), _c('wa-switch', {
    staticClass: "excel-button",
    on: {
      "change": _vm.itemShowHouseChange
    },
    model: {
      value: (_vm.itemShowShareHouseFlag),
      callback: function($$v) {
        _vm.itemShowShareHouseFlag = $$v
      },
      expression: "itemShowShareHouseFlag"
    }
  })], 1), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26f014b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SystemParameter.vue
// module id = 551
// module chunks = 1